module.exports = __webpack_public_path__ + "static/media/incident_switch_mobile.ad7e3ff1.png";